import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import { Box, makeStyles } from '@material-ui/core';

import DraggableTaskListItem from './DraggableTaskListItem';

const useStyles = makeStyles({
    container: {
        height: '100%',
        overflowY: 'auto',
    },
});

const DraggableTaskList = React.memo(({ items, lengthPrevItems, onDragEnd, onDelete }) => {
    const classes = useStyles();

    const itemEndRef = useRef(null);

    useEffect(() => {
        if (lengthPrevItems < items.length) {
            itemEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [items]);

    const handleDeleteTask = (removedItem) => {
        items = items.filter(i => i.id !== removedItem.id);
        onDelete(removedItem);
    };

    return (
        <Box className={classes.container}>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable-list">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {items.map((item, index) => (
                                <DraggableTaskListItem item={item} index={index} key={item.id} handleDeleteTask={handleDeleteTask} />
                            ))}
                            {provided.placeholder}
                            <div ref={itemEndRef}></div>
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </Box>
    );
});

DraggableTaskList.propTypes = {
    items: PropTypes.any,
    lengthPrevItems: PropTypes.number,
    onDragEnd: PropTypes.func,
    onDelete: PropTypes.func,
};

export default DraggableTaskList;